<template>
  <div v-if="isLoggedInUser" class="mt-5 border-t pt-6">
    <h3 class="font-semibold text-lg mb-4">{{ $t('product.writeReview') }}</h3>

    <BasicTextArea
      v-model="newReview.messaggio"
      :placeholder="$t('forms.writeReview')"
      class="w-full mt-4 border rounded-md p-3 focus:outline-none focus:ring focus:border-blue-300 resize-none"
    />

    <div class="d-flex align-items-center my-4 justify-content-between">
        <StarRatings
        v-model="newReview.voto"
        :numberOfStars="5"
        :star-size="28"
        :starColor="'#fbbf24'"
        :inactiveColor="'#d1d5db'"
        />
        <ButtonFilled
            class="fw-bold ms-md-4 text-center"
            :hasRoundedCorners="true"
            @click="submitReview"
            :disabled="submitting || !canSubmit"
            :text="submitting ? $t('common.submitting') : $t('common.submitReview')"
        />
    </div>
  </div>
</template>

<script>
import StarRatings from 'vue3-star-ratings'
import { addProductReview } from '../../../composables/manageReviews';
import ButtonFilled from '../Button/ButtonFilled.vue';
import BasicTextArea from '../FormInput/BasicTextArea.vue';

export default {
  components: { StarRatings, ButtonFilled, BasicTextArea },
  props: {
    productId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      newReview: {
        voto: 0,
        messaggio: ''
      },
      submitting: false,
    }
  },
  computed: {
    canSubmit() {
      return this.newReview.voto > 0 && this.newReview.messaggio.trim().length > 0;
    },
    isLoggedInUser() {
        return this.$store.getters["user/isLoggedInUser"];
    },
  },
  methods: {
    async submitReview() {
      if (!this.canSubmit) return;
      this.submitting = true;

      try {
        await addProductReview(this.productId, this.newReview);
        // Reset form
        this.newReview = { voto: 0, messaggio: '' };
        
        // Refresh reviews
        this.$emit('review-submitted');
      } catch (err) {
        console.error('Error submitting review:', err);
        alert('Failed to submit review.');
      } finally {
        this.submitting = false;
      }
    },
  }
}
</script>

<style scoped>
/* Optional additional styles */
</style>
